module.exports = __webpack_public_path__ + "static/media/appInfo3.2dc11014.png";